import * as end from 'constants/api'
import { axiosInstance } from 'services/axios-instance'

const SubscriptionServices = {
	setSubscription: payload => {
		return axiosInstance.post(end.setSubscription, payload).then(res => res.data)
	},
	getSubscription: ({ userId }) => {
		return axiosInstance.get(end.getInfoSubscription({ userId })).then(res => res.data)
	}
}

export default SubscriptionServices
